import classNames from 'classnames';
import AppContext from 'context/Context';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Collapse, Nav } from 'react-bootstrap';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';

const CollapseItems = ({ route }) => {
  const { pathname } = useLocation();

  const openCollapse = childrens => {
    const checkLink = children => {
      if (children.to === pathname) {
        return true;
      }
      return (
        Object.prototype.hasOwnProperty.call(children, 'children') &&
        children.children.some(checkLink)
      );
    };
    return childrens.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(route.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => {
          setOpen(!open);
        }}
        className={classNames('dropdown-indicator cursor-pointer', {
          'text-500': !route.active
        })}
        aria-expanded={open}
        disabled={!route.active}
        // {...route}
      >
        <NavbarVerticalMenuItem route={route} />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav" as="ul">
          <NavbarVerticalMenu routes={route.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
};

CollapseItems.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.array.isRequired,
    active: PropTypes.bool
  }).isRequired
};

const NavbarVerticalMenu = ({
  routes,
  monitoringLocationData,
  blockLocationData,
  firstEvaluationCluster,
  firstMonitoringCluster,
  firstBlockCluster
}) => {
  const {
    config: { showBurgerMenu },
    setConfig
  } = useContext(AppContext);

  const { pathname } = useLocation();
  const { cluster: clusterParam } = useParams();

  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
    setConfig('isNavbarVerticalCollapsed', true);
  };
  return routes.map(route => {
    if (!route.children) {
      return (
        <Nav.Item as="li" key={route.name} onClick={handleNavItemClick}>
          <NavLink
            end={route.exact}
            to={
              route.to.includes('evaluate')
                ? route.to +
                  '/' +
                  (clusterParam ? clusterParam : firstEvaluationCluster)
                : route.to.includes('monitor')
                ? route.to +
                  '/' +
                  (clusterParam &&
                  monitoringLocationData.some(item => item.key === clusterParam)
                    ? clusterParam
                    : firstMonitoringCluster)
                : route.to.includes('plotoverlay')
                ? route.to +
                  '/' +
                  (clusterParam &&
                  blockLocationData.some(item => item.key === clusterParam)
                    ? clusterParam
                    : firstBlockCluster)
                : route.to
            }
            state={{ open: route.to === '/authentication-modal' }}
            className={classNames('nav-link', {
              active: route.active && pathname.includes(route.to),
              'opacity-50 active':
                route.active &&
                route.to !== '#!' &&
                !pathname.includes(route.to),
              'nav-link nav-link-disabled': !route.active
            })}
          >
            <NavbarVerticalMenuItem route={route} />
          </NavLink>
        </Nav.Item>
      );
    }
    return <CollapseItems route={route} key={route.name} />;
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape(NavbarVerticalMenuItem.propTypes))
    .isRequired,
  firstEvaluationCluster: PropTypes.string,
  firstMonitoringCluster: PropTypes.string
};

export default NavbarVerticalMenu;
